import { useCallback, useMemo } from 'react';
import useStableSearchParams from '@/hooks/useStableSearchParams';
import { DateTime } from 'luxon';

function useDateRange() {
  const [searchParams, setSearchParams] = useStableSearchParams();

  // --- State from URL ---
  const from = searchParams.get('from');
  const to = searchParams.get('to');

  // Default dateRange to 3 days ago to now if not present
  function handleDefaultDateRange(from, to) {
    if (!from || !to) {
      const now = DateTime.now();
      const threeDaysAgo = now.minus({ days: 3 });
      from = threeDaysAgo.toISO();
      to = now.toISO();
    }
    return {
      from: DateTime.fromISO(from),
      to: DateTime.fromISO(to),
    };
  }

  const dateRange = useMemo(() => handleDefaultDateRange(from, to), [from, to]);

  const setDateRangeInUrl = useCallback(
    (range) => {
      setSearchParams((prev) => {
        const nextParams = new URLSearchParams(prev);
        if (range.from) nextParams.set('from', range.from.toISO());
        if (range.to) nextParams.set('to', range.to.toISO());
        return nextParams;
      });
    },
    [setSearchParams],
  );

  return [dateRange, setDateRangeInUrl];
}

export default useDateRange;
